export const ENDORSEMENT_STATUS = {
  undefined: 0,
  requestEmission: 1,
  internalized: 2,
  emmited: 3,
  canceled: 4
};

export const ENDORSEMENTS_BLOCK = ['policyIssued', 'canceled', 'renew'];

export const JUDICIAIS = {
  judicialId: 1,
  judicialDefaultId: 66,
  judicialDefaultExternalId: 66,
  judicialCivil: 23,
  judicialCivilId: 76,
  judicialRecursal: 62,
  judicialConvencionalExternalId: 122,
  judicialFiscalId: 44,
  judicialFiscal: 78
};

export const TRABALHISTA_RECURSAL = {
  judicialCivilId: 76,
  judicialConvencionalExternalId: 122
};

export const MOCK_MODALITIES = [
  'permission.policyholder.modality.performance.bond.services.provider',
  'permission.policyholder.modality.judicial.civil',
  'permission.policyholder.modality.advance.payment',
  // 'permission.policyholder.modality.judicial.labor'
  'permission.policyholder.modality.judicial.appeal'
];

export const MODALITIES = {
  eps: 97,
  epsInternal: 3,
  adiantamentoPagamento: 73,
  ...JUDICIAIS
};

export const EXPRESS_MODALITIES = [
  MODALITIES.eps,
  MODALITIES.judicialId,
  MODALITIES.judicialCivil,
  MODALITIES.judicialCivilId,
  MODALITIES.judicialFiscal,
  MODALITIES.judicialFiscalId,
  MODALITIES.judicialRecursal,
  MODALITIES.judicialDefaultExternalId,
  MODALITIES.judicialConvencionalExternalId,
  MODALITIES.adiantamentoPagamento
];

export const DOCUMENT_TYPE = {
  policy: 'policy',
  quote: 'quote'
};

export const CERTIFICATE_REGULARITY =
  'https://ms-gateway.juntoseguros.com/api_documents/certificateRegularity/download?format=pdf';
